var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalTradeIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_710_3015",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_710_3015)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1.18518,
    y: 0.59259,
    width: 32.5926,
    height: 32.5926,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_710_3015",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_710_3015",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAB2AAAAdgB+lymcgAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAASvSURBVHic7ZtfiFVFGMB/uzevm5m6tmpiVCSuZdGfh8BF3GQREeshk00KQjQWoZegDUoKCsIEySCxl6y3HmSDIEItAskIEtlVTAzTTBMr2zQ32m3xbtv28M3pjsfzb+ace+ZcvT/42HPuzHzn++acmfnmz0KDBvXEIuBB10a4YjlwGRgH1ji2JXfuAn4HJpT8DTzs1KIcmQYco+q8Jz8D8xzalQslYDdXO+9JPzDFmXU58C7hznvSBzS5MrCWPEu885684sjGmtGJ9PhJK+BfYK0TS2uAv8dPKtfMyPAV5s57ctT0Yc2ZmJwtaWyqmBYoYu/ZCjwCTFL3fTH5n1R//wH2A3+YPKyIFeBnIia9CbgRWAGUA9JPAEeyNipP4to9wDsR6ePAA2HKi9gH2DA3Iq0ZaI9KvK5pVIBrA1zTqADXBrimHiogKg4YT6u8Hirgk5Dfx4EP0iq/Ia2CHFhdS+X1EAoHMRd4DZip7juA2yLyfwOcU9dHgc3IGkJd0aZdb8F+yjwBdOVmtSVNwGJgG3AQ+BN5Y4+r9C6kD7BxfpDql1M4JgEbgdMEG38JmK/ybgrJEyUVYFkunliwEjhJvBOHgBZV5v0E+XXpyccVM0rA65h90u+psmVkESRJma15OGNKGfgUu7a8TuloA07F5N2DVHShKAG7sO/JR4GHlK5FSEcZlO8YMD0Ph0x5m3RD2QTwPXCz0rcKWRfU0y9Q7TQLxTLshrF+YMD3m75o+rL2u7/Hv79GvhgzmfBhLkoGkPigCRkJ9LTnNf3bgSHgae23XuA3ZKfZOT3Yfe76m+7zpVWAJSHPe4xq09icrSvmlEg21utyBon7OzU9HUC3kk1IBZzlynAZZKtsRNM1RDWGcEInZs7vB25KoPdzlf8zqsPdncCvATqdHq95M8CgMKkQsZyt0Q6c18odQPYJgpz3NyUrTNvuE1rZfoNyA1q5bmDY4tlB8pPuTB4rQie063sMyp3XrleSrCkk4XZghndjsyL0kWH+U+rvTMzO89ytXW9BXpZXCWVgARIB2tCOTLNz5V7SNZ8glmN3mGJpdm4lZ4GFoYPEr950W+j9X2fSNcEXkBUaG9YhE5c5XNmuTfgOiR+8AxAjSFDzg7o/A9xhoK8DGS0S44+8TOQ+paMMjKXQ45edmn17DMve4hXMYxTwxvIK2R1UGAb2avdR2+N+Lipxwg6Sv6VfSDaVXYhUblK9H2fmjQWPhhgVJHtDdOhMxfxU2TO6grBOMG6jwZR9yGdXAn5EgpE4xpC1wpPq/hyywQEyp+gC1ifU5TGKHLC+FJcxTacXJG9oul+11BE1HU4q2+Icr1UFXKQaBU5F3qapjkPIF9sMHLYoPwzM9juaVxMA+BKJ2kDO9e6y0HEYsdnm32Z6kXXIwvAh2X5lUbKbAm4ETwa+pvbOHwdmZWGwTcwdJM9pOtuQnr1Wzn+LhOCZkFUFjCELlR4tpNsgCZMv0ELeMEzaxWJkUpQFl4EXkaVqz471yLz/qp7akFHgJapRZ13RCryFDJumb/wvpJfPevRyQgvwFLL6dJZwp4dUng1YHnoo3NAQwq1ICDsNCaeHkIoZdGlUg2uB/wCGPYZ7J5uW2QAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalTradeIcon);
export default __webpack_public_path__ + "static/media/total_trade_icon.128c3080604c576f3c7002e7ac437fce.svg";
export { ForwardRef as ReactComponent };